import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { VerificaDocumentiCaricatiFilterComponent } from './verifica-documenti-caricati-filter';

export const VerificaDocumentiCaricatiFilterModule: string = ng
    .module('verifica-documenti-caricati-filter', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('verificaDocumentiCaricatiFilterComponent', VerificaDocumentiCaricatiFilterComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/component/verifica-documenti-caricati-filter/verifica-documenti-caricati-filter.module.ts